import Zliving1 from '../../../media/GW/Zliv.webp'
import Zliving2 from '../../../media/GW/Zliv.webp'


const Zlivingimages =[
Zliving1,Zliving2
]

export default Zlivingimages;